import React, { useEffect } from 'react';
import DashboardPage from '../views/DashboardView';
import DashboardIsNotAvailable from '../views/DashboardIsNotAvailable';
import { store } from 'components/App';
import { getUserHub } from 'modules/auth/selectors';
import { isCyHub } from 'modules/auth/helpers/hubs';
import saga from '../sagas';
import { useSelector } from 'react-redux';

const DashboardContainer = () => {
  const userHub = useSelector(getUserHub);
  useEffect(() => {
    store.injectSaga('DashboardContainer', saga);

    return () => {
      store.injectSaga('DashboardContainer', null);
    };
  }, []);

  if (!userHub) {
    return null;
  }

  if (isCyHub(userHub)) {
    return <DashboardIsNotAvailable />;
  }

  return <DashboardPage />;
};

export default DashboardContainer;
